import { render, staticRenderFns } from "./cardsMenu.vue?vue&type=template&id=3805a776"
import script from "./cardsMenu.vue?vue&type=script&lang=js"
export * from "./cardsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports